export default __webpack_public_path__ + "static/media/coming_soon.e1911735.gif";